import './inc/common';
import './inc/comment';

import highlight from 'highlight.js';
$(function () {
    highlight.initHighlighting();
    $('pre').each(assignCopyButton);
});

function initBuffer() {
    let buffer = $('#buffer');
    if (buffer) {
        buffer = $('<textarea type="text" readonly style="position: absolute; left: -9000px" id="buffer"></textarea>');
        $('body').append(buffer);
    }
    buffer.css({top: $(document).scrollTop()});
    return buffer;
}

function assignCopyButton(i, pre) {
    if (!pre ||
        pre.tagName !== 'PRE' ||
        pre.firstChild.tagName !== 'CODE'
    ) {
        return;
    }
    let copy = $('<div class="copy-button"></div>');
    copy.click(ev => {
        let buf = initBuffer();
        buf.val(pre.innerText);
        buf[0].select();
        document.execCommand('copy');
        return false;
    });
    $(pre).append(copy);
}
